'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (strings) {
	for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		values[_key - 1] = arguments[_key];
	}

	return (0, _index.styler)(strings, values, { expand: true });
};

var _index = require('./index');
//# sourceMappingURL=expanded.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-styling/build/expanded.js
// module id = 1595
// module chunks = 0